import type { MaybeRefOrGetter } from 'vue';
import type { FieldFilter, FilterOperator } from '#layers/data-model/public';
import type { UIFilterOperator } from '#layers/filters/components/Filter/utils/filter-ui-operator';
import { computed, toValue } from 'vue';
import { useI18n } from 'vue-i18n';
import { getFieldFilterOperatorName, isFilterOperator } from '#layers/data-model/public';

export function useFilterOperator(filter: MaybeRefOrGetter<FieldFilter>) {
	const { t } = useI18n();

	const operator = computed(() => getFieldFilterOperatorName(toValue(filter)));

	return {
		operator,
		getOperatorLabel,
	};

	function getOperatorLabel(operator: UIFilterOperator, operatorLabels?: Partial<Record<FilterOperator, string>>) {
		const override = isFilterOperator(operator) ? operatorLabels?.[operator] : undefined;
		return override ? t(override) : t(`filters.operators.${operator}`);
	}
}
